<cipo-dialog-header [titleParams]="{ driveName: driveName() }" title="folderDialog.saveFileInside" />
<mat-dialog-content>
    <div class="p-y" fxLayout fxLayoutAlign="start" fxLayoutGap="12px">
        @if (!data.entityInstanceId) {
            <div fxFlex>
                <mat-form-field class="cipo--width--full" appearance="outline">
                    <mat-label>{{ "folderDialog.folderName" | translate }}</mat-label>
                    <input matInput [formControl]="folderNameControl" />
                    <mat-hint>
                        {{ "folderDialog.saveFolderInside" | translate }}
                        {{ this.selectedNode()?.name ?? "folderDialog.root" | translate }}
                    </mat-hint>
                </mat-form-field>
            </div>
            <button
                fxFlex="none"
                mat-raised-button
                color="accent"
                class="m-t-sm"
                [disabled]="!folderNameControl.value"
                (click)="addFolder()">
                {{ "fileExplorer.addNewFolder" | translate }}
            </button>
        }
    </div>
    <cipo-folder-tree
        #folderTree
        [entityInstanceId]="data.entityInstanceId"
        [rootModuleId]="data.rootModuleId"
        [includeSearch]="true"
        (nodeClick)="selectedNode.set($event)" />
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>{{ "actions.cancel" | translate }}</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="!!folderNameControl.value">
        {{ "actions.saveTo" | translate }}
        <span class="cipo-text--medium-md">{{ selectedNode()?.name ?? "folderDialog.root" | translate }}</span>
    </button>
</mat-dialog-actions>
